import { render, staticRenderFns } from "./PaymentSocials.vue?vue&type=template&id=5c54a358&"
import script from "./PaymentSocials.vue?vue&type=script&lang=js&"
export * from "./PaymentSocials.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSocials.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports